import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/web/home'
import MobileHomeIndex from '@/views/mobile/mbhome'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/web',
    component: HomeIndex,
    children: [
      { path: '/web', component: () => import('@/views/web/index') },
      { path: '/web/about', component: () => import('@/views/web/about') },
      { path: '/web/business', component: () => import('@/views/web/business') },
      { path: '/web/business/information', component: () => import('@/views/web/information') },
      { path: '/web/team', component: () => import('@/views/web/team') },
      { path: '/web/team/explain', component: () => import('@/views/web/explain') },
      { path: '/web/join', component: () => import('@/views/web/join') },
      { path: '/web/contact', component: () => import('@/views/web/contact') },
      { path: '/web/news', component: () => import('@/views/web/news') },
      { path: '/web/news/understand', component: () => import('@/views/web/understand') },
    ]
  },
  {
    path: '/mobile',
    component: MobileHomeIndex,
    children: [
      { path: '/mobile', component: () => import('@/views/mobile/mbindex') },
      { path: '/mobile/about', component: () => import('@/views/mobile/mbabout') },
      { path: '/mobile/business', component: () => import('@/views/mobile/mbbusiness') },
      { path: '/mobile/business/information', component: () => import('@/views/mobile/mbinformation') },
      { path: '/mobile/team', component: () => import('@/views/mobile/mbteam') },
      { path: '/mobile/team/explain', component: () => import('@/views/mobile/mbexplain') },
      { path: '/mobile/join', component: () => import('@/views/mobile/mbjoin') },
      { path: '/mobile/contact', component: () => import('@/views/mobile/mbcontact') },
      { path: '/mobile/news', component: () => import('@/views/mobile/mbnews') },
      { path: '/mobile/news/understand', component: () => import('@/views/mobile/mbunderstand') },
    ]
  },
  // { path: '/test', component: () => import('@/views/test') },
  { path: '/404', component: () => import('@/views/404') },
  { path: '/500', component: () => import('@/views/500') },
  { path: '/502', component: () => import('@/views/502') },
  { path: '/*', component: () => import('@/views/404') }

]

// 防止连续点击多次路由报错
const routerPush = Router.prototype.push;
const routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})


// 路由切换时，判断是否为移动端，如果是则跳转到移动端页面
router.beforeEach((to, from, next) => {
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    if (to.path.indexOf('/web') !== -1) {
      next({ path: to.fullPath.replace('/web', '/mobile') })
    }
  } else {
    if (to.path.indexOf('/mobile') !== -1) {
      next({ path: to.fullPath.replace('/mobile', '/web') })
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js